module.exports = __webpack_public_path__ + "img/credit_list.ea29a98d.svg";